// Whether the Work board shows prices, totals and balances.
//
// Crew can see jobs but never money (DECISIONS §3). The server strips money
// from what Crew can load; this keeps the board from printing "$0.00" in its
// place. Work.tsx provides it; everything defaults to showing money.

import { createContext, useContext } from 'react'
import { useAuthStore } from '@/stores/authStore'
import { can } from '@/lib/permissions'

export const ShowMoneyContext = createContext(true)

/** Inside the Work board: may this person see money figures? */
export function useShowMoney(): boolean {
  return useContext(ShowMoneyContext)
}

/**
 * The same rule the server strips by (backend lib/moneyVisibility.ts
 * MONEY_CAPABILITIES = quotes, invoices, payments or reports view; the
 * frontend name for that set is 'viewMoney'). Before the session has loaded,
 * show it and let the server decide.
 */
export function useCanSeeWorkMoney(): boolean {
  const user = useAuthStore((s) => s.user)
  return !user || can(user, 'viewMoney')
}
